import Vue from 'vue'
import Vuex from 'vuex'
import * as getters from './getters'
import mutations from './mutations'
import actions from './actions'
// import standard from './index_standard.js' 
Vue.use(Vuex)
const store = new Vuex.Store({
	modules:{
		// standard, 
	},
  //定义状态
	state: {
		
	},
	getters,
	mutations,
	actions
})

export default store